import { render, staticRenderFns } from "./ProviderSlider.vue?vue&type=template&id=646950d0&scoped=true"
import script from "./ProviderSlider.vue?vue&type=script&lang=js"
export * from "./ProviderSlider.vue?vue&type=script&lang=js"
import style0 from "./ProviderSlider.vue?vue&type=style&index=0&id=646950d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646950d0",
  null
  
)

export default component.exports